export * from './lmi-proof-doc-skip-confirmation-dialog.component';
